<div class="material-checker-container d-flex flex-column">

    <div class="material-checker-content">
        <div class="dialogMessage topSection d-flex align-items-center">
            <div class="col-sm-3">
                <p class="dialogLabel">
                    {{'SIQUOTE_MATERIAL_CHECKER' | translate}}
                </p>
            </div>
            <div class="d-flex align-items-center col-sm-6">
                <mat-radio-group [(ngModel)]="selectedCheckType" [disabled]="isReadOnlyMode">
                    <mat-radio-button color="primary" value="fullpartcheck" class="small-radio d-flex align-items-center">
                        {{ 'FULL_PART_CHECK' | translate }}
                    </mat-radio-button>
                    <mat-radio-button color="primary" value="pricecheckonly" class="small-radio d-flex align-items-center">
                        {{ 'PRICE_CHECK_ONLY' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <hr>
        </div>

        <div class="dialogMessage main-content">
            @if(!checkCompleted){
                <div>
                    <p>{{ 'MATERIAL_CHECKER_DESCRIPTION' | translate }}</p>
                    <div class="checkSection">
                        <p class="checkLabel">
                            {{ 'CHECK' | translate }}
                        </p>
                        <div class="checkbox-group">
                            <mat-checkbox color="primary" class="checkbox-item" [(ngModel)]="standardLibrary" [disabled]="isReadOnlyMode">{{ 'STANDARD_LIBRARY' | translate }}</mat-checkbox>
                            <mat-checkbox color="primary" class="checkbox-item" [(ngModel)]="localLibrary" [disabled]="isReadOnlyMode">{{ 'LOCAL_LIBRARY' | translate }}</mat-checkbox>
                            <mat-checkbox color="primary" class="checkbox-item" [(ngModel)]="siParts" [disabled]="isReadOnlyMode">{{ 'SIPARTS' | translate }}</mat-checkbox>
                        </div>
                    </div>
                </div>
            }

            @if(checkCompleted){
                <div class="check-completed-container">
                    @if(!updateChangesCompleted){
                        <ng-container>
                            <div>
                                <p class="checkCompleted">{{ 'CHECK_COMPLETED' | translate }}</p>
                                @if(hasChanges){
                                    <p>{{ 'CHECK_COMPLETED_DESCRIPTION' | translate }}</p>
                                } @else {
                                    <p>{{ 'NO_CHANGES_FOUND' | translate }}</p>
                                }
                            </div>
                            @if(hasChanges){
                                <a class="custom-anchor" (click)="openChangesList()">{{ 'CLICK_HERE_FOR_LIST_OF_CHANGES' | translate }}</a>
                            }
                        </ng-container>
                    }
                    @else{
                        <div>
                            <p>{{ 'MATERIAL_CHECKER_UPDATE_COMPLETED' | translate }}</p>
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="material-checker-footer d-flex justify-content-end">
        @if (checkCompleted) {
            <button class="openCloseBtn" mat-raised-button color="primary" (click)="updateChanges()" [disabled]="isReadOnlyMode || updateChangesCompleted || !hasChanges">{{ 'UPDATE' | translate }}</button>
        }
        @if (!checkCompleted) {
            <button class="openCloseBtn" mat-raised-button color="primary" (click)="goNext()" [disabled]="isReadOnlyMode">{{ 'NEXT' | translate }}</button>
        }
        <button class="openCloseBtn" mat-raised-button color="warn" (click)="close()">{{'CLOSE' | translate}}</button>
    </div>

</div>
